var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{class:_vm.className,attrs:{"width":_vm.width,"height":_vm.height}},[_c('use',_vm._b({},'use',{ 'xlink:href': '#' + _vm.name },false))])
}
var staticRenderFns = []

export { render, staticRenderFns }